<template>
    <div class="bathrooms-filter">
        <h5>
            {{ label }}
        </h5>

        <div class="btn-group form-group" data-toggle="buttons">
            <template v-for="bathroom in 4">
                <label class="btn btn-primary" :class="current_value == bathroom ? 'active' : ''" :key="bathroom">
                    <input name="bathrooms" type="radio" :value="bathroom" v-model="current_value" @click="onClick(bathroom)"> {{ bathroom == 4 ? bathroom + '+' : bathroom }}
                </label>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Bagni',
        },

        value: {
            type: [String, Number],
            required: false,
        },
    },

    data() {
        return {
            current_value: this.value,
        }
    },

    methods: {
        onClick(value)
        {
            // console.log('Bathrooms - onClick', value, this.current_value)
            if(this.current_value == value)
            {
                this.current_value = null
                this.$emit('input', null)
            }
            else
            {
                this.$emit('input', value)
            }

            this.$emit('updated')
        },

        clearInput() {
            this.current_value = null
        },
    }
}
</script>